import { Mapper } from "../../../../base/utils/mapper";
import { DiagnosticModel } from "../../../../domain/models/configuration/diagnostic.model";
import { DiagnosticEntity } from "../entities/diagnostic.entity";


export class DiagnosticImplementationRepositoryMapper extends Mapper<DiagnosticEntity, DiagnosticModel> {
    mapFrom(param: DiagnosticEntity): DiagnosticModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DiagnosticModel): DiagnosticEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}